var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",on:{"click":_vm.navigateToHome}},[_c('b-img',{class:{'img-filter-blacknwhite':_vm.blacknwhite},attrs:{"height":_vm.height,"src":require('@/assets/images/logo/logo_mtca.png'),"alt":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }